import type { JSX } from "react";
import { useTranslation } from "react-i18next";

import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";

export function SpecialistRetailerForm({
  specialistRetailerName,
  specialistRetailerLocation,
  specialistRetailerContact,
  specialistRetailerCustomerNo,
  setSpecialistRetailerName,
  setSpecialistRetailerLocation,
  setSpecialistRetailerContact,
  setSpecialistRetailerCustomerNo,
  isGeolocationDE,
}: {
  specialistRetailerName: string;
  specialistRetailerLocation: string;
  specialistRetailerContact: string;
  specialistRetailerCustomerNo: string;
  setSpecialistRetailerName: (name: string) => void;
  setSpecialistRetailerLocation: (location: string) => void;
  setSpecialistRetailerContact: (contact: string) => void;
  setSpecialistRetailerCustomerNo: (customerNo: string) => void;
  isGeolocationDE: boolean;
}): JSX.Element {
  const { t } = useTranslation();

  const geolocationTag = isGeolocationDE
    ? "geolocationDE"
    : "geolocationDifferent";

  return (
    <>
      <Box
        display={"flex"}
        flexDirection={"column"}
        flex={1}
        flexBasis={"100%"}
      >
        <Typography>
          {t(
            `regiolux:dialog.requestQuote.${geolocationTag}.specialistRetailerText`,
          )}
        </Typography>
      </Box>
      <Box
        display={"flex"}
        flexDirection={"column"}
        flexBasis={"calc(50% - 0.5rem)"}
      >
        <Typography>
          {t(
            `regiolux:dialog.requestQuote.${geolocationTag}.specialistRetailerName`,
          )}
          *
        </Typography>
        <TextField
          value={specialistRetailerName}
          onChange={(event) => setSpecialistRetailerName(event.target.value)}
        />
      </Box>
      <Box
        display={"flex"}
        flexDirection={"column"}
        flexBasis={"calc(50% - 0.5rem)"}
      >
        <Typography>
          {t(
            `regiolux:dialog.requestQuote.${geolocationTag}.specialistRetailerLocation`,
          )}
          *
        </Typography>
        <TextField
          value={specialistRetailerLocation}
          onChange={(event) =>
            setSpecialistRetailerLocation(event.target.value)
          }
        />
      </Box>
      <Box
        display={"flex"}
        flexDirection={"column"}
        flexBasis={"calc(50% - 0.5rem)"}
      >
        <Typography>
          {t(
            `regiolux:dialog.requestQuote.${geolocationTag}.specialistRetailerContact`,
          )}
        </Typography>
        <TextField
          value={specialistRetailerContact}
          onChange={(event) => setSpecialistRetailerContact(event.target.value)}
        />
      </Box>
      <Box
        display={"flex"}
        flexDirection={"column"}
        flexBasis={"calc(50% - 0.5rem)"}
      >
        <Typography>
          {t(
            `regiolux:dialog.requestQuote.${geolocationTag}.specialistRetailerCustomerNo`,
          )}
        </Typography>
        <TextField
          value={specialistRetailerCustomerNo}
          onChange={(event) =>
            setSpecialistRetailerCustomerNo(event.target.value)
          }
        />
      </Box>
    </>
  );
}
